module.exports = __webpack_public_path__ + "img/4.dee3c81d.jpg";